import { createContext } from 'react';

export const PermissionsContext = createContext<{
  userId?: string;
  hasPermission: (key: string) => boolean;
  permissions: readonly string[];
}>({
  hasPermission: (key: string) => false,
  permissions: [],
});
